import React, { useState, useEffect, useRef } from "react";
import { Toaster, toast } from "react-hot-toast";
import { showToast } from "../../Helpers/showToast";
import { POST } from "../../Services/AxiosService";
import { HiMenuAlt1 } from "react-icons/hi";
import Sidebar from "../Sidebar/Sidebar";
import { CustomStringify } from "../../Helpers/CustomStringify";

import { useSelector, useDispatch } from "react-redux";
import { fetchDataPermit } from "../../Redux/PermitData/PermitDataSlice";
import { setActiveColumn } from "../../Redux/ActiveColumn/ActiveColumnSlice";
import { changeTheme } from "../../Redux/Theme/ThemeSlice";
// import { removeCompany } from "../../Redux/UserCompany/UserCompanySlice";

import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Drawer from "@mui/material/Drawer";
import Avatar from "@mui/material/Avatar";
import Stack from '@mui/material/Stack';
import Menu from "@mui/material/Menu";
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import { deepOrange, deepPurple } from '@mui/material/colors';
import AlignHorizontalRightIcon from '@mui/icons-material/AlignHorizontalRight';
import Settings from "@mui/icons-material/Settings";
import Logout from "@mui/icons-material/Logout";
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import AssignmentIcon from '@mui/icons-material/Assignment';
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { MuiColorInput } from "mui-color-input";
import { useLocation, useNavigate } from "react-router-dom";

import { setUserLevel } from "../../Redux/UserLevel/UserLevelSlice"
import { removeCompanyDetail } from "../../Redux/CompanyDetail/CompanyDetailSlice";
import { removeUserDetail } from "../../Redux/UserDetail/UserDetailSlice";

export default function Header() {
  const Theme = useSelector((state) => state.Theme);
  const { cmpdetail } = useSelector((state) => state.CompanyDetail);
  const UserDetail = useSelector((state) => state.UserDetail);
  const MenuData = useSelector((state) => state.MenuData?.result);
  const UserLevel = useSelector((state) => state.UserLevel);
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const menuOpen = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const logout = () => {
    localStorage?.removeItem("token");
    localStorage?.removeItem("user");
    dispatch(removeCompanyDetail());
    dispatch(removeUserDetail());
    navigate(`/`);
  };

  const insertTheme = async (newVal) => {
    var requestData = CustomStringify({
      Sett: {
        Sett_ColourTheme: newVal,
      },
      Server: {
        Database: cmpdetail?.Database,
        Password: cmpdetail?.Password,
        Server: cmpdetail?.Server,
        User_ID: cmpdetail?.User_ID,
        Port: cmpdetail?.Port,
      },
    });

    try {
      const result = await POST(`/Setting_InsertUpdate`, requestData);
      return result;
    } catch (error) {
      console.log("error", error)
    }
  };

  const debounceTimerRef = useRef(null);

  const handleChangeColor = (newValue) => {
    dispatch(changeTheme(newValue));

    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }
    debounceTimerRef.current = setTimeout(() => {
      insertTheme(newValue);
    }, 2000);
  };


  const theme = createTheme({
    breakpoints: {
      values: {
        tab: 992,
      },
    },
    palette: {
      primary: {
        main: Theme.primaryThemeColor,
      },
    },
    typography: {
      fontFamily: "Poppins",
      h4: {
        fontWeight: "600",
        fontSize: "18px",
        color: Theme.primaryThemeColor,
        "@media (max-width: 768px)": {
          fontSize: "16px",
        },
      },
      h5: {
        fontWeight: "600",
        fontSize: "17px",
        color: Theme.primaryThemeColor,
        "@media (max-width: 768px)": {
          fontSize: "15px",
        },
      }
    },
    components: {
      MuiInputBase: {
        styleOverrides: {
          input: {
            width: "65px",
            height: "5px",
            fontSize: "13px"
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            width: "75px",
            height: "36px",
          },
        },
      },
    },
  });

  const normal = createTheme({
    breakpoints: {
      values: {
        tab: 992,
      },
    },
    palette: {
      primary: {
        main: Theme.primaryThemeColor,
      },
    },
    typography: {
      fontFamily: "Poppins",
      h4: {
        fontWeight: "600",
        fontSize: "18px",
        color: Theme.primaryThemeColor,
        "@media (max-width: 768px)": {
          fontSize: "16px",
        },
      },
      h5: {
        fontWeight: "600",
        fontSize: "17px",
        color: Theme.primaryThemeColor,
        "@media (max-width: 768px)": {
          fontSize: "15px",
        },
      }
    },
    components: {
      MuiInputBase: {
        styleOverrides: {
          input: {
            fontSize: "14px"
          },
        },
      },
    },
  });

  useEffect(() => {
    if (MenuData?.length > 0) {
      let MenuId = MenuData?.filter((item) => {
        return item?.MenuPath == location.pathname.split("/")[1];
      })[0]?.Menu_ID;

      if (MenuId) {
        dispatch(fetchDataPermit({ cmpdetail, MenuId }));
      }

      dispatch(setActiveColumn(location.pathname.split("/")[1]));
    }
  }, [location.pathname, MenuData]);

  return (
    <>
      <ThemeProvider theme={theme}>
        <AppBar
          position="static"
          style={{ height: "35px", backgroundColor: "#fff" }}
        >
          <Box
            sx={{
              display: "flex",
              height: "100%",
              justifyContent: "space-between",
              alignItems: "center",
              mx: 2,
            }}
          >
            <Drawer open={open} onClose={toggleDrawer(false)}>
              <Sidebar callBack={toggleDrawer(false)} />
            </Drawer>
            <div style={{ display: "flex", alignItems: "center" }}>
              <IconButton
                size="large"
                edge="start"
                aria-label="menu"
                sx={{ color: "#000" }}
                onClick={toggleDrawer(true)}
              >
                <HiMenuAlt1 style={{ fontSize: "22px" }} />
              </IconButton>
              <Typography variant="h4">
                {UserDetail?.result?.user?.company_name}
              </Typography>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              {/* <ThemeProvider theme={normal}>
                <FormControl>
                  <Select
                    labelId="demo-select-small-label"
                    id="demo-select-small"
                    value={UserLevel}
                    label="Rows"
                    onChange={(event) => dispatch(setUserLevel(event.target.value))}
                    sx={{
                      '& legend': { display: 'none' },
                      '& .MuiInputLabel-shrink': { opacity: 0, transition: "all 0.2s ease-in" },
                      width: "150px",
                      height: "25px",
                      mx: 2,
                      mt: 0.8
                    }}
                  >
                    <MenuItem value={1}>Super Admin</MenuItem>
                    <MenuItem value={2}>Admin</MenuItem>
                    <MenuItem value={3}>Manager</MenuItem>
                  </Select>
                </FormControl>
              </ThemeProvider> */}
              <Stack
                direction="row"
                spacing={1}
                sx={{
                  mr: 2,
                  alignItems: "center",
                }}
              >
                <Button
                  variant="contained"
                  size="small"
                  onClick={() => navigate("/mnuFGDesign")}
                  sx={{
                    minWidth: "75px",
                    width: "auto",
                    height: "28px",
                    px: 1.5,
                    fontSize: "12px",
                    fontWeight: 600,
                    textTransform: "none",
                    borderRadius: "5px",
                    whiteSpace: "nowrap",
                  }}
                >
                  Design
                </Button>

                <Button
                  variant="contained"
                  size="small"
                  onClick={() => navigate("/PackingChallan")}
                  sx={{
                    minWidth: "120px",
                    width: "auto",
                    height: "28px",
                    px: 1.5,
                    fontSize: "12px",
                    fontWeight: 600,
                    textTransform: "none",
                    borderRadius: "5px",
                    whiteSpace: "nowrap",
                  }}
                >
                  Packing Challan
                </Button>
              </Stack>
              <Typography variant="h5">
                {UserDetail?.result?.user?.user_name}
              </Typography>
              <Avatar
                sx={{
                  bgcolor: Theme.primaryThemeColor,
                  cursor: "pointer",
                  height: "26px",
                  width: "26px",
                  mx: 1
                }}
                onClick={handleClick}
              >
                <CorporateFareIcon sx={{ fontSize: "16px" }} />
              </Avatar>
            </div>
            <Menu
              anchorEl={anchorEl}
              id="account-menu"
              open={menuOpen}
              onClose={handleClose}
              PaperProps={{
                elevation: 0,
                sx: {
                  overflow: "visible",
                  filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                  mt: 1.5,
                  "& .MuiAvatar-root": {
                    width: 80,
                    height: 80,
                    ml: -0.5,
                    mr: 1,
                  },
                  "&::before": {
                    content: '""',
                    display: "block",
                    position: "absolute",
                    top: 0,
                    right: 14,
                    width: 10,
                    height: 10,
                    bgcolor: "background.paper",
                    transform: "translateY(-50%) rotate(45deg)",
                    zIndex: 0,
                  },
                },
              }}
              transformOrigin={{ horizontal: "right", vertical: "top" }}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            >
              <IconButton
                aria-label="close"
                disableFocusRipple={true}
                onClick={handleClose}
                sx={{ position: "absolute", top: 0.1, left: 0.1 }}
              >
                <AlignHorizontalRightIcon />
              </IconButton>
              <Stack direction="column" spacing={1} sx={{ px: 3, py: 1, alignItems: "center", width: 220 }}>
                {/* <Avatar sx={{ bgcolor: Theme?.primaryThemeColor }}>{cmpdetail?.company_name?.[0]?.toUpperCase()}</Avatar> */}
                <Avatar><img src={`https://application.eterp.in/files/master/${cmpdetail?.logo}`} className="" style={{ width: "100%" }} /></Avatar>
                <Typography variant="h5">{cmpdetail?.company_name}</Typography>
              </Stack>
              <Divider sx={{ borderBottomWidth: 2 }} />
              {/* <Typography variant="subtitle2" align="center" sx={{ pt: 1 }}>Change Theme</Typography> */}
              {/* <Stack direction="row" spacing={1} sx={{ px: 1, py: 1 }}>
                <MuiColorInput
                  format="hex"
                  value={Theme.primaryThemeColor}
                  onChange={handleChangeColor}
                />
                <Button
                  variant="contained"
                  size="small"
                  onClick={() => {
                    return (
                      dispatch(changeTheme("#5198CD")),
                      insertTheme("#5198CD")
                    );
                  }}
                  sx={{ background: "#5198CD" }}
                >
                  Default
                </Button>
              </Stack> */}
              <Divider sx={{ borderBottomWidth: 2 }} />
              <MenuItem onClick={logout}>
                <ListItemIcon>
                  <Logout fontSize="small" />
                </ListItemIcon>
                Logout
              </MenuItem>
            </Menu>
          </Box>
        </AppBar>
      </ThemeProvider>
      <Toaster position="top-center" reverseOrder={false} />
    </>
  );
}
